import { Button, Box, Icon, Paper, useTheme, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TableFooter, LinearProgress, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom"
import { useEffect, useState, useMemo } from "react";

import { IUnidade, UnidadeService } from "../../shared/services/api/unidade/UnidadeService";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { Environment } from "../../shared/environment";
import { AlertSnackBar, AutoCompleteDeCliente } from "../../shared/components";
import { IPaginacao } from "../../shared/services/api/axios-config";
import Pagination from "@mui/lab/Pagination";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";

export const ListagemDeUnidadeDesativada: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [isLoading, setIsLoading] = useState(false);
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [rows, setRows] = useState<IUnidade[]>([]);
  const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }
  useEffect(() => {
    handleNewSearch(false);
  }, [cnpj]);

  useEffect(() => {
    handleNewSearch(true);
  }, [pagina]);

  const handleNewSearch = (newPage: boolean) => {
    setIsLoading(true);

    if (cnpj === undefined || cnpj === null || cnpj == '') {
      setIsLoading(false);
      setRows([]);
      setSearchParams({ pagina: "1" }, { replace: true })
      resetPaginacao();
    } else {
      if (newPage) {

        UnidadeService.getByCnpj(pagina, cnpj, false).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          } else {
            setRows(result.unidades);
            setPaginacao(result.paginacao);
          }
        });

      } else {
        setSearchParams({ pagina: "1" }, { replace: true })
        setRows([]);
        resetPaginacao();
        UnidadeService.getByCnpj(1, cnpj, false).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          } else {
            setRows(result.unidades);
            setPaginacao(result.paginacao);
          }
        });
      }
    }


  };

  // useEffect(() => {
  //   setIsLoading(true);

  //   if (cnpj === undefined || cnpj === null || cnpj == '') {
  //     setIsLoading(false);
  //     setRows([]);
  //   } else {
  //     UnidadeService.getByCnpj(pagina, cnpj, false).then((result) => {
  //       setIsLoading(false);

  //       if (result instanceof Error) {
  //         setAlert({ tipoAlert: "erro", mensagem: result.message });
  //         setTimeout(() => {
  //           setAlert(undefined);
  //         }, duracaoAlert);
  //       } else {
  //         setRows(result.unidades);
  //         setPaginacao(result.paginacao);
  //       }
  //     });
  //   }
  // }, [pagina, cnpj]);

  const handleReable = () => {
    setAbrir(false);
    setIsLoading(true);
    UnidadeService.toggleEnabledById(idToReable)
      .then(result => {
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlert({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        } else {
          setRows(oldRows => {
            return [
              ...oldRows.filter(oldRow => oldRow.idUnidade !== idToReable),
            ]
          });
          setAlert({ tipoAlert: "sucesso", mensagem: "Área reativada" });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);

        }
      });
  }

  const [abrir, setAbrir] = useState(false);
  const [idToReable, setidToReable] = useState<number>(0);

  const handleClickReable = (idUsuario: number) => {
    setAbrir(!abrir);
    setidToReable(idUsuario);
  };

  const handleCancel = () => {
    setAbrir(false);
  };

  return (
    <LayoutBaseDePagina
      titulo="Listagem de áreas desativadas"
      barraDeFerramentas={null}
    >
      <DialogConfirm
        AoConfirmar={handleReable}
        titulo={"Dejesa realmente reativar a área?"}
        texto={"Ao confirmar, a área e tudo que está contida nela será reativado."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      {alert !== undefined && (
        <>
          {alert.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}
      <Box
        component={Paper}
        height={theme.spacing(5)}
        marginX={1}
        padding={1}
        paddingX={2}
        display="flex"
        gap={1}
        alignItems="center"
      >
        <AutoCompleteDeCliente selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />

        <Box flex={1} display="flex" justifyContent="end">
          <Button
            color="primary"
            disableElevation
            variant="contained"
            endIcon={<Icon>add</Icon>}
            onClick={() => navigate('/unidade/detalhe/nova')}
          >
            Nova
          </Button>
        </Box>
      </Box>

      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell align="center"> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.idUnidade}>
                <TableCell> {row.nomeUnidade} </TableCell>
                <TableCell align="center">
                  <Button
                    color="primary"
                    disableElevation
                    variant="contained"
                    onClick={() => handleClickReable(row.idUnidade)}
                  >
                    Reativar
                  </Button>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao.totalCount === 0 && !isLoading && cnpj !== undefined && cnpj !== null && cnpj !== '' && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}
          {cnpj === undefined || cnpj === null || cnpj == '' && !isLoading && (
            <caption> Selecione uma empresa para pesquisar </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={2}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {paginacao.totalPages > 1 && (
              <TableRow>
                <TableCell colSpan={2} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>

    </LayoutBaseDePagina>
  )
}
